// Canadian income-tax engine (marginal + average rates) built on the dated data layer.
import { FEDERAL_TAX_BRACKETS, PROVINCIAL_TAX_BRACKETS } from "./financial-data/canada";

const taxFromBrackets = (income, brackets) => {
  let tax = 0;
  let lower = 0;
  for (const b of brackets) {
    if (income > lower) {
      const taxable = Math.min(income, b.upTo) - lower;
      tax += taxable * b.rate;
      lower = b.upTo;
    } else break;
  }
  return tax;
};

const marginalRate = (income, brackets) => {
  let rate = brackets[brackets.length - 1].rate;
  let lower = 0;
  for (const b of brackets) {
    if (income <= b.upTo) {
      rate = b.rate;
      break;
    }
    lower = b.upTo;
  }
  return rate;
};

// Returns combined federal + provincial figures. Ignores credits (documented as a limitation).
export function estimateTax(income, provinceCode = "ON") {
  const prov = PROVINCIAL_TAX_BRACKETS.provinces[provinceCode] || PROVINCIAL_TAX_BRACKETS.provinces.ON;
  const fed = taxFromBrackets(income, FEDERAL_TAX_BRACKETS.brackets);
  const provTax = taxFromBrackets(income, prov.brackets);
  const totalTax = fed + provTax;
  const marginal =
    marginalRate(income, FEDERAL_TAX_BRACKETS.brackets) + marginalRate(income, prov.brackets);
  return {
    federalTax: fed,
    provincialTax: provTax,
    totalTax,
    afterTax: income - totalTax,
    marginalRate: marginal,
    averageRate: income > 0 ? totalTax / income : 0,
  };
}
